// src/pages/PrivacyPolicyPage.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiShield, FiLock, FiDatabase, FiUserCheck } from 'react-icons/fi';
import './LegalPage.css';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <FiShield className="legal-icon" />
          <h1>{t('privacy.title')}</h1>
          <p className="legal-date">{t('privacy.lastUpdated')}: 5 de novembro de 2025 / November 5, 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. {t('privacy.section1.title')}</h2>
            <p>{t('privacy.section1.content')}</p>
          </section>

          <section className="legal-section">
            <div className="section-header">
              <FiDatabase />
              <h2>2. {t('privacy.section2.title')}</h2>
            </div>
            
            <h3>2.1 {t('privacy.section2.sub1.title')}</h3>
            <ul>
              <li>{t('privacy.section2.sub1.item1')}</li>
              <li>{t('privacy.section2.sub1.item2')}</li>
              <li>{t('privacy.section2.sub1.item3')}</li>
              <li>{t('privacy.section2.sub1.item4')}</li>
            </ul>

            <h3>2.2 {t('privacy.section2.sub2.title')}</h3>
            <p>{t('privacy.section2.sub2.content')}</p>
            <ul>
              <li>{t('privacy.section2.sub2.item1')}</li>
              <li>{t('privacy.section2.sub2.item2')}</li>
              <li>{t('privacy.section2.sub2.item3')}</li>
              <li>{t('privacy.section2.sub2.item4')}</li>
            </ul>

            <h3>2.3 {t('privacy.section2.sub3.title')}</h3>
            <ul>
              <li>{t('privacy.section2.sub3.item1')}</li>
              <li>{t('privacy.section2.sub3.item2')}</li>
              <li>{t('privacy.section2.sub3.item3')}</li>
              <li>{t('privacy.section2.sub3.item4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. {t('privacy.section3.title')}</h2>
            <p>{t('privacy.section3.intro')}</p>
            <ul>
              <li>{t('privacy.section3.item1')}</li>
              <li>{t('privacy.section3.item2')}</li>
              <li>{t('privacy.section3.item3')}</li>
              <li>{t('privacy.section3.item4')}</li>
              <li>{t('privacy.section3.item5')}</li>
            </ul>
            
            <div className="info-box">
              <FiUserCheck />
              <p>
                <strong>{t('privacy.section3.aiNotice.title')}:</strong> {t('privacy.section3.aiNotice.content')}
              </p>
            </div>
          </section>

          <section className="legal-section">
            <div className="section-header">
              <FiLock />
              <h2>4. {t('privacy.section4.title')}</h2>
            </div>
            <p>{t('privacy.section4.content')}</p>
            <ul>
              <li>{t('privacy.section4.item1')}</li>
              <li>{t('privacy.section4.item2')}</li>
              <li>{t('privacy.section4.item3')}</li>
              <li>{t('privacy.section4.item4')}</li>
              <li>{t('privacy.section4.item5')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. {t('privacy.section5.title')}</h2>
            <p>{t('privacy.section5.intro')}</p>
            <ul>
              <li><strong>{t('privacy.section5.coach.title')}:</strong> {t('privacy.section5.coach.content')}</li>
              <li><strong>{t('privacy.section5.strava.title')}:</strong> {t('privacy.section5.strava.content')}</li>
              <li><strong>{t('privacy.section5.providers.title')}:</strong> {t('privacy.section5.providers.content')}</li>
              <li><strong>{t('privacy.section5.legal.title')}:</strong> {t('privacy.section5.legal.content')}</li>
            </ul>
            <p><strong>{t('privacy.section5.noSale')}</strong></p>
          </section>

          <section className="legal-section">
            <h2>6. {t('privacy.section6.title')}</h2>
            <p>{t('privacy.section6.intro')}</p>
            <ul>
              <li>{t('privacy.section6.item1')}</li>
              <li>{t('privacy.section6.item2')}</li>
              <li>{t('privacy.section6.item3')}</li>
              <li>{t('privacy.section6.item4')}</li>
              <li>{t('privacy.section6.item5')}</li>
              <li>{t('privacy.section6.item6')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. {t('privacy.section7.title')}</h2>
            <p>{t('privacy.section7.content')}</p>
          </section>

          <section className="legal-section">
            <h2>8. {t('privacy.section8.title')}</h2>
            <p>
              {t('privacy.section8.content')} 
              <a href="https://www.strava.com/legal/api" target="_blank" rel="noopener noreferrer"> {t('privacy.section8.linkText')}</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. {t('privacy.section9.title')}</h2>
            <p>{t('privacy.section9.content')}</p>
          </section>

          <section className="legal-section">
            <h2>10. {t('privacy.section10.title')}</h2>
            <p>{t('privacy.section10.intro')}</p>
            <div className="contact-box">
              <p><strong>{t('privacy.section10.email')}:</strong> privacy@podiumrun.com</p>
              <p><strong>{t('privacy.section10.support')}:</strong> support@podiumrun.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
